export type ProviderName = 'trusstor' | 'genba';

/** The known providers as a runtime array — keep in sync with `ProviderName`.
 *  Source for the `isProvider` guard and any provider iteration. */
export const PROVIDER_NAMES = ['trusstor', 'genba'] as const satisfies readonly ProviderName[];

/**
 * Extra inputs for connecting an upstream provider. Genba needs its tenant API
 * root URL (it encodes the tenant); Trusstor omits it.
 */
export interface IConnectProviderOptions {
  rootUrl?: string;
}
